// TimeseriesCard — renderer for viz: timeseries. Wraps the generic
// TimeseriesChart in the shared FlowCard chrome. Reads meta.granularity
// ("hourly" | "daily") to set the axis time-axis + card label (hourly for short
// windows, daily for long ones — so YTD isn't thousands of hourly points), and
// labels the span "over <window>" from the global selection. Empty series ->
// tidy empty state.

import { useContext } from 'react';

import { OptionsFlowContext } from '../../../../providers/options-flow/options-flow-provider';
import { windowLabel } from '../../../../providers/options-flow/options-flow.helpers';
import { TimeseriesReport } from '../../../../providers/options-flow/types';
import { FlowCard } from '../flow-card';
import { FlowEmptyState } from '../flow-empty-state';
import { TimeseriesChart } from '../timeseries-chart';

interface TimeseriesCardProps {
  report: TimeseriesReport;
}

export const TimeseriesCard = ({ report }: TimeseriesCardProps) => {
  const { activeWindow } = useContext(OptionsFlowContext);
  const series = report.series ?? [];
  const hasData = series.some((s) => (s.points ?? []).length > 0);

  // "hourly"/"daily" drives the x-axis; default hourly (short-window default).
  const granularity = report.meta.granularity === 'daily' ? 'daily' : 'hourly';

  const caption = [
    activeWindow ? `${granularity} · over ${windowLabel(activeWindow)}` : `${granularity} buckets`,
    'blue above 0 = net bought, red below = net sold',
  ].join(' · ');

  return (
    <FlowCard title={report.title} caption={caption}>
      {hasData ? (
        <TimeseriesChart
          series={series}
          yFormat={report.y_format}
          reference={report.meta.reference}
          granularity={granularity}
        />
      ) : (
        <FlowEmptyState height={260} />
      )}
    </FlowCard>
  );
};
